import { createUseStyles } from 'react-jss'
import { darkGrey, lightGrey, mediumGrey, trafficRedDark } from '../../../styles/const/colors'
import { defaultBorderRadius, transitionShort } from '../../../styles/const/common'
import { placeholderColor } from '../../../styles/mixins/common'
import { fontFamily } from '../../../styles/typography'

const useStyles = createUseStyles(theme => ({
  wrapper: {
    width: '100%'
  },
  textAreaWrapper: {
    position: 'relative'
  },
  textarea: {
    fontFamily: fontFamily,
    padding: ({ hasEmojiPicker }) => (hasEmojiPicker ? '11px 50px 11px 14px' : '11px 14px'),
    resize: 'none',
    minWidth: '100%',
    maxWidth: '100%',
    minHeight: 40,
    margin: 0,
    overflow: 'hidden',
    border: '1px solid',
    borderRadius: defaultBorderRadius,
    borderColor: props => (props.showError ? [trafficRedDark, '!important'] : lightGrey),
    outline: 'none',
    '&:focus': {
      borderColor: theme.brandPrimary
    },
    ...placeholderColor(mediumGrey)
  },
  icon: {
    cursor: 'pointer',
    marginTop: '1px',
    position: 'absolute',
    right: 17,
    top: 14,
    transition: transitionShort,
    fontSize: '14px',
    lineHeight: '20px',
    color: darkGrey
  }
}))

export default useStyles
